// extracted by mini-css-extract-plugin
export default {"logo":"QuickSetupTypeWrap_logo__-qFNb","title":"QuickSetupTypeWrap_title__DYGNH"};